<template>
    <main>
        <section class="bg-gray-light py-10 sm:py-16">
            <div class="container text-left mx-auto px-4">
                <h3 class="text-green-dark text-2xl sm:text-4xl font-semibold"><strong>FAQ:</strong> {{ $t("Alcune domande frequenti") }}</h3>
                <div class="rounded-2xl bg-white mt-6 shadow-sm" v-for="faq, i in faqs" :key="i">
                    <div class="header font-bold text-sm px-8 py-4" @click="activeFaq = i" :class="{'cursor-pointer': activeFaq != i}">
                        <h5 class="float-left w-4/5">{{ faq.q }}</h5>                        
                        <svg v-if="i == activeFaq" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                        </svg>
                        <svg v-if="i != activeFaq" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        <div class="clear-both"></div>
                    </div>
                    <div class="body px-8 py-4 text-sm border-t border-gray-200" v-if="i == activeFaq">
                        <p>{{ faq.a }}</p>
                    </div>
                </div>

            </div>
        </section>      
    </main>
</template>
<script>
import arrowLeftIco from '@/svg/arrow-left.vue'
import arrowRightIco from '@/svg/arrow-right.vue'
import faqsIT from '@/data/it/faqs.json'
import faqsEN from '@/data/en/faqs.json'

export default {
    data() {
        return {
            activeFaq: 0
        }
    },
    components: {arrowRightIco, arrowLeftIco},
    computed: {
        faqs() {
            if(this.$i18n.locale == 'it')
                return faqsIT
            else 
                return faqsEN
        }
    }
}
</script>
</script>